import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Portfolio from "./pages/Portfolio";
import ProductDesign from "./pages/ProductDesign";
import MobileDevelopment from "./pages/MobileDevelopment";
import WebDevelopment from "./pages/WebDevelopment";
import BackendDevelopment from "./pages/BackendDevelopment";
import BlockchainDevelopment from "./pages/BlockchainDevelopment";
import AIDevelopment from "./pages/AIDevelopment";
import StartAProject from "./pages/StartAProject";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TheHomeDepot from "./pages/TheHomeDepot";
import Klokbox from "./pages/Klokbox";
import Deltra from "./pages/Deltra";
import Finutss from "./pages/Finutss";
import Bullz from "./pages/Bullz";
import Telly from "./pages/Telly";

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize WOW.js for animations
    if (window.WOW) {
      new window.WOW({ offset: 100 }).init();
    } else {
      // Load WOW.js if not already loaded
      const script = document.createElement("script");
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js";
      script.integrity =
        "sha512-Eak/29OTpb36LLo2r47IpVzPBLXnAMPAVypbSZiZ4Qkf8p/7S/XRG5xp7OKWPPYfJT6metI+IORkR5G8F900+g==";
      script.crossOrigin = "anonymous";
      script.referrerPolicy = "no-referrer";
      script.onload = () => {
        new window.WOW({ offset: 100 }).init();
      };
      document.body.appendChild(script);
    }

    // Close modal on overlay click
    const handleOverlayClick = (e) => {
      if (
        e.target.classList.contains("overlay") ||
        e.target.classList.contains("close")
      ) {
        document.body.classList.remove("open-modal");
      }
    };

    document.addEventListener("click", handleOverlayClick);

    return () => {
      document.removeEventListener("click", handleOverlayClick);
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/product-design" element={<ProductDesign />} />
          <Route path="/mobile-development" element={<MobileDevelopment />} />
          <Route path="/web-development" element={<WebDevelopment />} />
          <Route path="/backend-development" element={<BackendDevelopment />} />
          <Route
            path="/blockchain-development"
            element={<BlockchainDevelopment />}
          />
          <Route path="/ai-development" element={<AIDevelopment />} />
          <Route path="/start-a-project" element={<StartAProject />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/the-home-depot" element={<TheHomeDepot />} />
          <Route path="/klokbox" element={<Klokbox />} />
          <Route path="/deltra" element={<Deltra />} />
          <Route path="/finutss" element={<Finutss />} />
          <Route path="/bullz" element={<Bullz />} />
          <Route path="/telly" element={<Telly />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
